/**
 * Static category icons for the plan cards. The W2 offering wire carries no
 * carrier field (plan §5), so — exactly as B2C does — cards are keyed by
 * category to the existing `public/images/*` assets rather than derived from API
 * data. All paths are confirmed present on disk.
 */
const CATEGORY_ICON: Record<string, string> = {
  Medical: '/images/health-plan.png',
  Dental: '/images/dental.svg',
  Vision: '/images/vision.svg',
  Accident: '/images/accident.svg',
  'Critical Illness': '/images/criticalillness.svg',
  'Hospital Indemnity': '/images/hospital.svg',
};

/** The icon for a (normalized) category, or undefined for an unknown bucket. */
export function categoryIcon(category: string): string | undefined {
  return CATEGORY_ICON[category];
}
